<template>
  <v-simple-table>
    <thead>
      <tr>
        <th style="width: 80px">task id</th>
        <th style="width: 80px">ステータス</th>
        <th style="min-width: 250px"></th>
        <th>同期開始日</th>
        <th>確認日</th>
        <th style="width: 80px"></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="session in sessions" :key="session.id">
        <td>{{ session.taskId }}</td>
        <td>
          <v-chip v-if="session.completed"  color="success">完了</v-chip>
          <v-chip v-else color="warning">未完了</v-chip>
        </td>
        <td>{{ session.taskStatusI18N }}</td>
        <td>{{ session.createdAt | momentDatetime }}</td>
        <td>{{ session.latestCheckedAt | momentDatetime }}</td>
        <td>
          <SyncStatusConfirmButtonContainer v-if='!session.completed' :session-id="session.id" @update-session='updateSession' />
        </td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
import SyncStatusConfirmButtonContainer from '../../../../src/container/pages/MailMagazineSettings/SyncStatusConfirmButtonContainer'
import moment from 'moment'

export default {
  name: 'OnamaeTableContainer',
  components: {
    SyncStatusConfirmButtonContainer
  },
  props: {
    sessions: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    momentDatetime: function (val) {
      if (val) {
        return moment(val).format('YYYY/MM/DD HH:mm')
      }
    }
  },
  methods: {
    updateSession (updatedSession) {
      this.$emit('update-session', updatedSession)
    }
  }
}
</script>
